import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule as PrimeNgSharedModule } from 'primeng/api';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { NgIdleModule } from '@ng-idle/core';
import { LeftSidebarMenuModule } from './shared/components/left-sidebar-menu/left-sidebar-menu.module';
import { AppComponent } from './app.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AgilityLoadingModule } from './custom/agility-loading/agility-loading.module';
import { AuthModule } from '@auth0/auth0-angular';
import { Auth0ConfigService } from './shared/services/auth0-config.service';
import { UrlParamsService } from './shared/services/url-params.service';
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    PrimeNgSharedModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    NgIdleModule.forRoot(),
    InfiniteScrollModule,
    LeftSidebarMenuModule,
    AgilityLoadingModule,
    AuthModule.forRoot({
          ...(() => {
            const configService = new Auth0ConfigService();
            return configService.getConfig().auth;
          })(),
          skipRedirectCallback: new UrlParamsService(document).hasErrorParams(),
          httpInterceptor: (() => {
            const configService = new Auth0ConfigService();
            return configService.getConfig().httpInterceptor;
          })(),
        }),
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
